import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { IActivity } from "./activityModal";
import { API_PORTAL_URL } from "@/lib/config";

export const getAllActivity = createAsyncThunk(
  "Activity/FindAllActivity",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Activity/FindAllActivity`,
        { Title: "" },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getActivityByURL = createAsyncThunk(
  "Activity/ActivityFindByURL",
  async (ActivityURL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Activity/ActivityFindByURL`,
        { ActivityURL },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ActivityName: result.ActivityName,
        ActivityURL: result.ActivityURL,
        Duration: result.Duration,
        DifficultyType: result.DifficultyType,
        Availability: result.Availability,
        Description: result.Description,
        ShortDescription: result.ShortDescription,
        WhatsInclude: result.WhatsInclude,
        ImportantTips: result.ImportantTips,
        IsShowOnHome: result.IsShowOnHome,
        MainImage: result.MainImage,
        BannerImage: result.BannerImage,
        MetaTitle: result.MetaTitle,
        MetaDescription: result.MetaDescription,
        MetaKeywords: result.MetaKeywords,
        ActivityBannerImage: result.ActivityBannerImage,
        ActivityTimeline: result.ActivityTimeline,
        IsActive: result.IsActive ? 1 : 2,
      } as IActivity;
    } catch (error: any) {
      console.error("Error fetching Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveActivity = createAsyncThunk(
  "Activity/FindAllActiveActivity",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Activity/FindAllActiveActivity`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createActivity = createAsyncThunk(
  "Activity/InsertActivity",
  async (ActivityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Activity/InsertActivity`,
        ActivityData,
      );
      return response.data;
    } catch (error: any) {
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateActivity = createAsyncThunk(
  "Activity/UpdateActivity",
  async (ActivityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Activity/UpdateActivity`,
        ActivityData,
      );
      return response.data;
    } catch (error: any) {
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteActivity = createAsyncThunk(
  "Activity/DeleteActivity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Activity/DeleteActivity`,
        { ID },
      );
      return response.data;
    } catch (error: any) {
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveActivity = createAsyncThunk(
  "Activity/ActiveInActiveActivity",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Activity/ActiveInActiveActivity`,
        formData,
      );
      return response.data;
    } catch (error: any) {
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActivityImageUpload = createAsyncThunk(
  "ActivityImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/ActivityImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      return response.data;
    } catch (error: any) {
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
